// extracted by extract-css-chunks-webpack-plugin
module.exports = {"financeInformation":"s05uk"};